import React, { useMemo } from "react";
import ButtonComponent from "../../../components/buttonComponent";
import RefreshIcon from '@mui/icons-material/Refresh';
import DownloadIcon from '@mui/icons-material/Download';

const AllOrdersPageHeader = (props) => {
  const {
    setProvider,
    isInternal,
    supplierName,
    providerList,
    handleTableRefresh,
    downloadButtonFunc,
    isLoading, 
  } = props;

  const pl = useMemo(
    () =>
      providerList.sort(function (a, b) {
        return a.descr.localeCompare(b.descr, "en", { sensitivity: "base" });
      }),
    [providerList]
  );

  return (
    <div id="allorders-page-header-div" className="w-full flex !justify-between !flex-nowrap !ml-0 !mr-0">
      {isInternal ? (
        <div id="allorders-select-fwder-div" className="pt-2 items-center !flex-grow-0 !w-full">
          <h6>
            <select
              className="cstm-select focus:outline-none focus:shadow-green-700 focus:shadow-md text-[0.8rem] w-3/4 block ml-[4%]"
              id="inputGroupSelect01"
              onChange={(evt) => setProvider(evt.target.value)}
              disabled={isLoading}
              title={isLoading? "Please wait...":""}
            >
              <option value="" id="">
                Select Forwarder
              </option>
              {pl.map((providerOption) => (
                <option
                  value={providerOption.sapSuplrNo}
                  id={providerOption.providerId}
                  key={providerOption.providerId}
                >
                  {providerOption.descr}
                </option>
              ))}
            </select>
          </h6>
        </div>
      ) : (
        <h6 className="text-[0.8rem] w-full pt-3 text-left pl-4 font-semibold">
          {supplierName}
        </h6>
      )}
      <div className="!w-full pt-3">
        <p className="text-xs text-center">
          <b id="allorders-title">All Orders</b>
        </p>
      </div>
      <div className="flex !w-full space-x-2  justify-end">
        <ButtonComponent
          handleFunction={handleTableRefresh}
          tooltip={"Refresh Data"}
          variant={null}
        >
          <RefreshIcon style={{ fontSize: '20px' }} />
        </ButtonComponent>
        <ButtonComponent
          handleFunction={downloadButtonFunc}
          tooltip={"Download"}
          variant={null}
        >
          <DownloadIcon style={{ fontSize: '20px' }} />
        </ButtonComponent>
      </div>
    </div>
  );
};

export default AllOrdersPageHeader;
